var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import { styled, themeGet } from "@twilio-paste/styling-library";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { keyframes } from "@twilio-paste/styling-library";
var SkeletonLoaderKeyframes = keyframes`
  0% {
    transform: translateX(-100%) skew(155deg);
  }
  50%,
  100% {
    transform: translateX(100%) skew(155deg);
  }
`;
var SkeletonLoaderInner = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    90deg,
    transparent,
    ${themeGet("backgroundColors.colorBackground")} 40%,
    ${themeGet("backgroundColors.colorBackground")} 60%,
    transparent
  );
  transform: translateX(-100%) skew(155deg);
  animation-timing-function: cubic-bezier(0.06, 0.42, 0.57, 0.89);
  animation-name: ${SkeletonLoaderKeyframes};
  animation-duration: 4.5s;
  animation-iteration-count: infinite;
`,
  SkeletonLoader = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        borderBottomLeftRadius,
        borderBottomRightRadius,
        borderRadius = "borderRadius20",
        borderTopLeftRadius,
        borderTopRightRadius,
        element = "SKELETON_LOADER",
        display,
        height = "sizeIcon20",
        maxHeight,
        maxWidth,
        minHeight,
        minWidth,
        size = null,
        width = null
      } = _b,
      props = __objRest(_b, ["borderBottomLeftRadius", "borderBottomRightRadius", "borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "element", "display", "height", "maxHeight", "maxWidth", "minHeight", "minWidth", "size", "width"]);
    return React.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
      "aria-busy": "true",
      backgroundColor: "colorBackgroundStrong",
      borderBottomLeftRadius,
      borderBottomRightRadius,
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      display,
      element,
      height,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      overflow: "hidden",
      pointerEvents: "none",
      position: "relative",
      userSelect: "none",
      size,
      width,
      ref
    }), React.createElement(SkeletonLoaderInner, null));
  });
SkeletonLoader.displayName = "SkeletonLoader";
export { SkeletonLoader };